import { Typography, Box } from '@mui/material'

export const Footer = () => {
  return (
    <Box
      bgcolor='#000'
      minHeight={150}
      color='#fff'
      px={3}
      py={5}
      display='flex'
      justifyContent='space-between'
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems='center'
    >
      <Box mb={3} order={{ sm: 2, xs: 2, md: 1, lg: 1 }} textAlign='center'>
        <Typography variant='h4' color='white'>
          Copyright © {new Date().getFullYear() ?? ''}. All Rights Reserved.
        </Typography>
      </Box>
      <Box order={{ sm: 1, xs: 1, md: 2, lg: 2 }} mb={1}>
        {/* <Link href="https://www.facebook.com/MobilLubricantsMalaysia" newTab>
          <Tooltip title="Facebook">
            <IconButton>
              <FacebookIcon fontSize="large" style={{ fill: "white" }} />
            </IconButton>
          </Tooltip>
        </Link> */}
      </Box>
    </Box>
  )
}
